var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxContent"},[_c('div',{staticClass:"setUser-table"},[_c('div',{class:{
        'setUser-tap-left': true,
        'setUser-overall': _vm.actived === 0,
        'setUser-Single': !(_vm.actived === 0),
      },on:{"click":function($event){return _vm.changeListShow(0)}}},[_vm._v(" 会话查看 ")]),_c('div',{class:{
        'setUser-tap-right': true,
        'setUser-overall': _vm.actived === 1,
        'setUser-Single': !(_vm.actived === 1),
      },on:{"click":function($event){return _vm.changeListShow(1)}}},[_vm._v(" 会话检索 ")]),_c('div',{class:{
        'setUser-tap-right': true,
        'setUser-overall': _vm.actived === 2,
        'setUser-Single': !(_vm.actived === 2),
      },on:{"click":function($event){return _vm.changeListShow(2)}}},[_vm._v(" 敏感词 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }